export default __webpack_public_path__ + "arrow-dashed.56d9c11c71afa214.svg";